<template>
  <div>
    <!-- HEADER -->
    <v-layout>
      <v-flex
        lg6
        offset-lg3>
        <!-- ROW 1.1: ID, SITE, EDIT BUTTON -->
        <v-layout
          align-center
          justify-center>
          <router-link
            :to="{ name: 'site', params: { id: issue.site } }"
            class="headline clickable">
            <b>{{ issue.site }}</b>
          </router-link>
        </v-layout>
        <v-layout
          align-center
          justify-space-between>
          <v-flex shrink>
            <v-layout align-center>
              <span class="headline">
                {{ issue.id | formatIId }}
              </span>
              <v-tooltip
                v-if="issue.category && issue.category.name"
                right>
                <v-chip
                  slot="activator"
                  class="ml-3"
                  color="yellow lighten-3"
                  disabled
                  label
                  outline
                  small>
                  <v-icon left>category</v-icon>
                  {{ issue.category.name }}
                </v-chip>
                {{ issue.category.description }}
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-btn
            :disabled="issue.id === 0"
            class="ma-0"
            flat
            icon
            @click="dialog = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-layout>
        <!-- ROW 1.2: DESCRIPTION -->
        <v-layout v-if="issue.description">
          <div class="mb-2 caption">{{ issue.description }}</div>
        </v-layout>
        <v-divider/>
        <!-- ROW 1.3: CHIPS: O/C[, STATUS], CLOSE/RE-OPEN BUTTON -->
        <v-layout
          v-if="issue.id > 0"
          align-center
          justify-space-between>
          <v-flex shrink>
            <!-- CHIP: OPEN -->
            <v-tooltip
              v-if="!issue.dateClosed"
              left>
              <v-chip
                slot="activator"
                label
                small
                disabled
                class="mx-0"
                color="red darken-1 white--text">
                OPEN
              </v-chip>
              <span>{{ issue.dateRaised | formatLLL }}</span>
            </v-tooltip>
            <!-- CHIP: CLOSED -->
            <v-tooltip
              v-else
              left>
              <v-chip
                slot="activator"
                label
                small
                disabled
                class="mx-0"
                color="white--text green darken-1">
                CLOSED
              </v-chip>
              <span>{{ issue.dateClosed | formatLLL }}</span>
            </v-tooltip>
            <!-- CHIP: STATUS -->
            <v-tooltip
              v-if="issue.status && issue.status.name"
              right>
              <v-chip
                slot="activator"
                label
                small
                outline
                disabled
                color="white">
                <v-icon left>label</v-icon>
                {{ issue.status.name }}
              </v-chip>
              {{ issue.status.description }}
            </v-tooltip>
          </v-flex>
          <!-- CLOSE BUTTON -->
          <v-btn
            v-if="!issue.dateClosed"
            :disabled="posting"
            outline
            small
            color="green lighten-3"
            class="mx-0"
            @click="close">
            <v-progress-circular
              v-if="posting"
              size="15"
              indeterminate/>
            <span v-else>Close</span>
          </v-btn>
          <v-btn
            v-else
            :disabled="posting"
            outline
            small
            color="red lighten-3"
            class="mx-0"
            @click="update({dateClosed: null})">
            <v-progress-circular
              v-if="posting"
              size="15"
              indeterminate/>
            <span v-else>Re-open</span>
          </v-btn>
        </v-layout>
        <!-- JOBS -->
        <assigned-jobs
          v-if="issue.id > 0"
          :closed="issue.dateClosed !== null"
          :issue-id="issue.id"
          :jobs="jobs"/>
        <!-- Comments -->
        <comments/>
      </v-flex>
    </v-layout>
    <!-- EDIT DIALOG -->
    <edit-dialog
      v-model="dialog"
      :issue="issue"
      @saved="refresh"/>
  </div>
</template>

<script>
import moment from "moment";
import AssignedJobs from "./Issue/AssignedJobs.vue";
import Comments from "./Issue/Comments.vue";
import EditDialog from "./Issue/EditDialog.vue";

export default {
  components: {
    AssignedJobs,
    Comments,
    EditDialog
  },
  data () {
    return {
      // Boolean to toggle the edit dialog
      dialog: false,
      // The issue under review
      issue: {
        id: 0,
        site: "< Site >"
      },
      jobs: [],
      posting: false
    };
  },
  created () {
    // Get information on the issue to be edited
    const { id } = this.$route.params;
    this.$http.
      get(`/api/issues/${id}`).
      then((r) => this.issue = Object.assign({}, r.data));
    // Get the jobs assigned to this issue
    this.$http.
      get(`/api/jobs?issue=${id}`).
      then((r) => this.jobs = Array.from(r.data));
  },
  methods: {
    close () {
      this.update({ dateClosed: moment().format("YYYY-MM-DDTHH:mm:ss") });
    },
    refresh () {
      this.dialog = false;
      this.$http.
        get(`/api/issues/${this.issue.id}`).
        then((r) => this.issue = Object.assign({}, r.data));
    },
    // Utils
    update (updateObj) {
      this.posting = true;
      this.$http.
        put(`/api/issues/${this.issue.id}`, updateObj).
        then(() => {
          this.$http.
            get(`/api/issues/${this.issue.id}`).
            then((r) => Object.assign(this.issue, r.data));
        }).
        finally(() => this.posting = false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Issue.vue